// useToast.js
import { showGlobalToast } from './toastService';

export const useToast = () => {
  return showGlobalToast;
};
